export default "__VITE_ASSET__DRiLkcB2__"